const Pages = {
    ConfigList: [
        { ID: 1, Page: "CompanyInfo", Name: "Company Info" },
        { ID: 2, Page: "Users", Name: "Users" },
        { ID: 3, Page: "Roles", Name: "Roles" },
        { ID: 4, Page: "Organization", Name: "Organization" },
        { ID: 5, Page: "RoleAccess", Name: "Role Access" },
        { ID: 6, Page: "EmailSettings", Name: "Email Settings" },
        { ID: 7, Page: "MerchantCode", Name: "Merchant Codes" },
        { ID: 8, Page: "Wallet", Name: "Wallet" },
        { ID: 25, Page: "IDCard", Name: "User ID Card" },
        { ID: 33, Page: "EBusinessCard", Name: "E-Business Card" },
        { ID: 27, Page: "IBA", Name: "IBA Page" },
        { ID: 35, Page: "EmailConfig", Name: "Email Configuration" },
        { ID: 37, Page: "PartnerDirectory", Name: "Partner Directory" },
        { ID: 40, Page: "EventRecords", Name: "Event Records" }

    ],
    EnquiryList: [
        { ID: 9, Page: "NewEnquiry", Name: "New Enquiry" },
        { ID: 10, Page: "ManageEnquiry", Name: "Manage Enquiry" },
        { ID: 11, Page: "Survey", Name: "Goods Survey" },
        { ID: 12, Page: "ManageSurvey", Name: "Manage Survey" },
        { ID: 17, Page: "Insurance", Name: "Insurance" }
    ],
    QuotationList: [
        { ID: 13, Page: "CreateQuotation", Name: "Create Quotation" },
        { ID: 14, Page: "GenerateQuotation", Name: "Generate Quotation" },
        { ID: 15, Page: "QuotationRecords", Name: "Quotation Records" },
    ],
    LRDocList: [
        { ID: 18, Page: "CreateLR", Name: "Create LR Document" },
        { ID: 19, Page: "GenerateLR", Name: "Generate LR Document" },
        { ID: 20, Page: "LRRecords", Name: "LR Records" }
    ],
    TrackingList: [
        { ID: 16, Page: "TrackingDetails", Name: "Tracking Details" },
        { ID: 28, Page: "ManageTrip", Name: "Manage Trip" },
        { ID: 32, Page: "TrackRecords", Name: "Track Records" },
        { ID: 34, Page: "TrackReport", Name: "Member Tracking Report" },
        { ID: 39, Page: "TrackLimits", Name: "Tracking Limits" }
    ],
    InvoiceList: [
        { ID: 21, Page: "Invoice", Name: "Create Invoice" },
        { ID: 22, Page: "GenerateInvoice", Name: "Generate Invoice" },
        { ID: 23, Page: "InvoiceRecords", Name: "Invoice Records" },
        { ID: 24, Page: "CreditNotes", Name: "Credit Notes" }
    ],
    ServReqList: [
        { ID: 26, Page: "InternalReq", Name: "Internal Request" },
        { ID: 38, Page: "IServRecords", Name: "IServ Records" }
    ],
    DashBoardList: [
        { ID: 29, Page: "AdminDashBoard", Name: "Admin DashBoard" },
        { ID: 30, Page: "PartnerDashBoard", Name: "Partner DashBoard" },
        { ID: 31, Page: "Alert", Name: "Configure Alerts" },
        { ID: 36, Page: "Calendar", Name: "Calendar" }
    ],
    TotalPages: [
        { ID: 1, Page: "CompanyInfo" },
        { ID: 2, Page: "Users" },
        { ID: 3, Page: "Roles" },
        { ID: 4, Page: "Organization" },
        { ID: 5, Page: "RoleAccess" },
        { ID: 6, Page: "EmailSettings" },
        { ID: 7, Page: "MerchantCode" },
        { ID: 8, Page: "Wallet" },
        { ID: 9, Page: "NewEnquiry" },
        { ID: 10, Page: "ManageEnquiry" },
        { ID: 11, Page: "Survey" },
        { ID: 12, Page: "ManageSurvey" },
        { ID: 13, Page: "CreateQuotation" },
        { ID: 14, Page: "GenerateQuotation" },
        { ID: 15, Page: "QuotationRecords" },
        { ID: 16, Page: "TrackingDetails" },
        { ID: 17, Page: "Insurance" },
        { ID: 18, Page: "CreateLR" },
        { ID: 19, Page: "GenerateLR" },
        { ID: 20, Page: "LRRecords" },
        { ID: 21, Page: "Invoice" },
        { ID: 22, Page: "GenerateInvoice" },
        { ID: 23, Page: "InvoiceRecords" },
        { ID: 24, Page: "CreditNotes" },
        { ID: 25, Page: "IDCard" },
        { ID: 26, Page: "InternalReq" },
        { ID: 27, Page: "IBA" },
        { ID: 28, Page: "ManageTrip" },
        { ID: 29, Page: "AdminDashBoard" },
        { ID: 30, Page: "PartnerDashBoard" },
        { ID: 31, Page: "Alert" },
        { ID: 32, Page: "TrackRecords" },
        { ID: 33, Page: "EBusinessCard" },
        { ID: 34, Page: "TrackReport" },
        { ID: 35, Page: "EmailConfig" },
        { ID: 36, Page: "Calendar" },
        { ID: 37, Page: "PartnerDirectory" },
        { ID: 38, Page: "IServRecords" },
        { ID: 39, Page: "TrackLimits" },
        { ID: 40, Page: "EventRecords" }
    ]
};
export default Pages;